import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {DataService} from '../../../Services/data.service';
import {BsToastService} from '../../../Services/bs-toast-service';
import {DateFilterService} from '../../../Services/dateFilter.service';

@Component({
  selector: 'app-crm-log-interaction-modal',
  templateUrl: './crm-log-interaction-modal.component.html',
  styleUrls: [],
  standalone: false,
})
export class CrmLogInteractionModalComponent implements OnChanges {

  @Input() visible = false;
  @Input() entityId: string | null = null;
  @Input() opportunityId: string | null = null;
  @Input() companyId: string | null = null;
  @Input() title = 'Log Interaction';

  @Output() saved = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  isSaving = false;

  readonly interactionTypes = ['call', 'email', 'meeting', 'demo', 'site_visit', 'note'];
  readonly outcomeOptions = ['positive', 'neutral', 'negative', 'no_answer'];

  model: any = {};

  constructor(
    private dataService: DataService,
    private notification: BsToastService,
    private dateFilter: DateFilterService,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible'] && this.visible) {
      this.resetModel();
    }
  }

  private resetModel(): void {
    const d = new Date();
    this.model = {
      interaction_type: 'call',
      subject: '',
      body: '',
      outcome: 'positive',
      duration_minutes: 5,
      follow_up_required: false,
      interaction_date: {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()},
      follow_up_date: '',
    };
  }

  cancel(): void {
    this.cancelled.emit();
  }

  save(): void {
    if (!this.model.subject || !this.model.interaction_type) {
      this.notification.showErrorToast('Subject and Type are required.');
      return;
    }
    this.isSaving = true;
    const payload = {
      ...this.model,
      interaction_date: this.dateFilter.GetDateFormat(this.model.interaction_date) || null,
      follow_up_date: this.dateFilter.GetDateFormat(this.model.follow_up_date) || null,
      entity_id: this.entityId ?? null,
      opportunity_id: this.opportunityId ?? null,
      company_id: this.companyId ?? null,
    };
    this.dataService.post('crm_interaction', payload).subscribe({
      next: () => {
        this.notification.showSuccessToast('Interaction logged.');
        this.isSaving = false;
        this.saved.emit();
      },
      error: () => {
        this.notification.showErrorToast('Failed to save interaction.');
        this.isSaving = false;
      },
    });
  }
}
